var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgQuestionMark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MVP_Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    className: "premiumIcon",
    id: "Menu-Options",
    transform: "translate(-266.000000, -165.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281,165 C272.72,165 266,171.72 266,180 C266,188.28 272.72,195 281,195 C289.28,195 296,188.28 296,180 C296,171.72 289.28,165 281,165 Z M282.5,190.5 L279.5,190.5 L279.5,187.5 L282.5,187.5 L282.5,190.5 Z M285.605,178.875 L284.255,180.255 C283.175,181.35 282.5,182.25 282.5,184.5 L279.5,184.5 L279.5,183.75 C279.5,182.1 280.175,180.6 281.255,179.505 L283.115,177.615 C283.67,177.075 284,176.325 284,175.5 C284,173.85 282.65,172.5 281,172.5 C279.35,172.5 278,173.85 278,175.5 L275,175.5 C275,172.185 277.685,169.5 281,169.5 C284.315,169.5 287,172.185 287,175.5 C287,176.82 286.46,178.02 285.605,178.875 Z",
    id: "Shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgQuestionMark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/question_mark.787c304c1a54d642310d27adcd631fbf.svg";